import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { useAlerts } from 'breeze-intelligence-kit';
import { DataTestContext } from './context';
import { useCurrentUser } from 'policy-lib';
import { useEnrichableObjectTypes } from '../../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataTestContextProvider = ({
  children,
  onClose,
  onEnrichmentStart,
  objectTypeId,
  selectionIds
}) => {
  const currentUser = useCurrentUser();
  const {
    addAlertDanger,
    addAlertSuccess
  } = useAlerts();
  const {
    companyLabelLowercase,
    companyLabelPluralLowercase,
    contactLabelLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  const initialContext = {
    addAlertDanger,
    addAlertSuccess,
    companyLabelLowercase,
    companyLabelPluralLowercase,
    contactLabelLowercase,
    contactLabelPluralLowercase,
    currentUser,
    objectTypeId: objectTypeId,
    onClose,
    onEnrichmentStart,
    selectionIds,
    shouldOverwrite: true
  };
  const dataTestMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(DataTestContext.Provider, {
    value: dataTestMachine,
    children: children
  });
};